import { tempConfig } from "./interface";
import { category } from "./interface";

export const state = {
  tempConfig: tempConfig,
  category: category
};
